import { Link } from "react-router-dom";
import { QUICK_LINKS } from "./constance";

function QAFooter() {
  return (
    <div className="md:order-2">
      <h4 className="flex items-center gap-2 text-lg font-black text-white">
        <span className="h-5 w-1 rounded-full bg-floodlight" />
        دسترسی سریع
      </h4>

      <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-3">
        {QUICK_LINKS.map((l) => (
          <li key={l.path}>
            <Link
              to={l.path}
              className="group inline-flex items-center gap-2 text-sm text-white/60 transition-all hover:translate-x-[-4px] hover:text-floodlight"
            >
              <span className="h-1 w-1 rounded-full bg-white/30 transition-colors group-hover:bg-floodlight" />
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default QAFooter;
